import React from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.web';
import './web-fonts';
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);
root.render(<App />);
